/**
 * html 转 text 文字过滤器
 * @param {string} html html 字符串
 */
export default function (html) {
  if (!html) {
    return '暂无数据'
  }
  return html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&')
}
